import { analyticsApiClient } from '../api/analyticsApi';
import apiClient from '../api/apiClient';
import type {
  DataModel,
  QuerySpec,
  QueryResult,
  ListModelsResponse,
  ValidateResponse,
  PreviewSQLResponse,
  SavedReportConfig,
  CreateSavedReportRequest,
  UpdateSavedReportRequest,
} from '../types/reportBuilder';

export const reportBuilderService = {
  // --- Analytics API (models, query execution) ---

  async listModels(module?: string): Promise<ListModelsResponse> {
    const params = module ? { module } : undefined;
    const response = await analyticsApiClient.get('/report-builder/models', { params });
    return response.data;
  },

  async getModel(key: string): Promise<DataModel> {
    const response = await analyticsApiClient.get(`/report-builder/models/${key}`);
    return response.data;
  },

  async executeQuery(spec: QuerySpec): Promise<QueryResult> {
    const response = await analyticsApiClient.post('/report-builder/query', spec);
    return response.data;
  },

  async validateQuery(spec: QuerySpec): Promise<ValidateResponse> {
    const response = await analyticsApiClient.post('/report-builder/validate', spec);
    return response.data;
  },

  async previewSQL(spec: QuerySpec): Promise<PreviewSQLResponse> {
    const response = await analyticsApiClient.post('/report-builder/preview-sql', spec);
    return response.data;
  },

  // --- Core API (report builder CRUD) ---

  async listSavedReports(): Promise<SavedReportConfig[]> {
    const response = await apiClient.get('/report-builder');
    return response.data.data;
  },

  async getSavedReport(id: string): Promise<SavedReportConfig> {
    const response = await apiClient.get(`/report-builder/${id}`);
    return response.data.data;
  },

  async createSavedReport(req: CreateSavedReportRequest): Promise<SavedReportConfig> {
    const response = await apiClient.post('/report-builder', req);
    return response.data.data;
  },

  async updateSavedReport(id: string, req: UpdateSavedReportRequest): Promise<SavedReportConfig> {
    const response = await apiClient.put(`/report-builder/${id}`, req);
    return response.data.data;
  },

  async deleteSavedReport(id: string): Promise<void> {
    await apiClient.delete(`/report-builder/${id}`);
  },

  // --- Publish as Widget ---

  async getPublishStatus(id: string) {
    const response = await apiClient.get(`/report-builder/${id}/publish-status`);
    return response.data.data;
  },

  async publishAsWidget(id: string, data: { title: string; description: string; chart_type: string; layout_default_width: number; layout_default_height: number }) {
    const response = await apiClient.post(`/report-builder/${id}/publish-as-widget`, data);
    return response.data.data;
  },

  async updatePublishedWidget(id: string, data: { title: string; description: string; chart_type: string; layout_default_width: number; layout_default_height: number }) {
    const response = await apiClient.put(`/report-builder/${id}/published-widget`, data);
    return response.data.data;
  },

  async unpublishWidget(id: string): Promise<void> {
    await apiClient.delete(`/report-builder/${id}/published-widget`);
  },
};
